/* Soulbuddy 30.10.2026: „Passt perfekt dazu“ auf der Produktseite zeigt 2 Produkte nebeneinander (vorher 1).
   Karten flach: kleines Bild links, daneben Name und Preis, kleiner Warenkorb-Knopf rechts (Flo: wenig Scrolltiefe). Mobil 1 Produkt pro Ansicht (flacher Balken), ab 768 px 2. Warenkorb-Knopf 36 px, Name 14,5 px, Preis 15,5 px.
   Bei nur 1 Produkt bleibt es bei 1 Karte (breit wie vorher); Endlos-Schleife nur ab 3 Produkten. */
if (!customElements.get('complementary-product-slider')) {
  (function () {
    if (document.getElementById('sb-comp2-css')) return;
    var s = document.createElement('style');
    s.id = 'sb-comp2-css';
    s.textContent =
      'complementary-product-slider.sb-two .swiper-slide{height:auto}' +
      'complementary-product-slider.sb-two .product-card--list{height:100%;box-sizing:border-box;padding:8px!important}' +
      'complementary-product-slider.sb-two .product-card--list .product-card__wrapper{position:relative;flex-direction:row;align-items:flex-start;gap:8px;height:auto;min-height:100%;padding:0!important}' +
      'complementary-product-slider.sb-two .product-card--list .product-card__image-wrapper{width:48px!important;min-width:48px;max-width:48px!important;flex:none}' +
      'complementary-product-slider.sb-two .product-card--list .product-card__image-wrapper .media-wrapper{width:48px!important;height:48px!important}' +
      'complementary-product-slider.sb-two .product-card--list .product-card__info{position:static;flex:1 1 auto;min-width:0;flex-direction:column;align-items:flex-start;justify-content:flex-start;gap:2px;padding:0!important}' +
      'complementary-product-slider.sb-two .product-card--list .product-card__title{width:100%;margin:0;font-size:14.5px!important;line-height:1.25;display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical;overflow:hidden}' +
      'complementary-product-slider.sb-two .product-card--list .f-price{width:auto;font-size:13px!important;flex-wrap:wrap;gap:0 4px}' +
      'complementary-product-slider.sb-two .product-card--list .f-price .f-price-item{font-size:15.5px!important;line-height:1.3}' +
      'complementary-product-slider.sb-two .product-card--list .f-price s,complementary-product-slider.sb-two .product-card--list .f-price__sale .f-price-item--regular{font-size:12px!important}' +
      'complementary-product-slider.sb-two .product-card--list .product-card__atc{position:absolute;left:auto;right:0;top:50%;transform:translateY(-50%);bottom:auto;width:36px!important;height:36px!important;min-width:0!important;min-height:0!important;padding:0!important;margin:0}' +
      'complementary-product-slider.sb-two .product-card--list .product-card__atc svg,complementary-product-slider.sb-two .product-card--list .product-card__atc-icon{width:19px!important;height:19px!important}' +
      /* 30.10.2026: Seitenzahl „1/1“ ausblenden, wenn alle Produkte (max. 2) auf einmal sichtbar sind; mobil Karte hoch genug fuer den Warenkorb-Knopf unter dem Bild */
      /* 30.10.2026 (spät): mobil nur 1 Produkt als flacher, durchgehender grauer Balken (Bild links, Name/Preis Mitte, Warenkorb-Knopf rechts); ab 768 px 2 nebeneinander */
      'complementary-product-slider.sb-two .product-card--list .product-card__wrapper{align-items:center}complementary-product-slider.sb-two .product-card--list .product-card__info{padding-right:46px!important}' +
      '@media (min-width:768px){complementary-product-slider.sb-fit .slider-controls--group,complementary-product-slider.sb-fit .swiper-pagination,complementary-product-slider.sb-fit .swiper-button-prev,complementary-product-slider.sb-fit .swiper-button-next{display:none!important}}';
    document.head.appendChild(s);
  })();
  customElements.define(
    'complementary-product-slider',
    class ComplementaryProductSlider extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        /* 30.10.2026: Produkte, die schon im Kasten „Direkt mitbestellen“ stehen, hier nicht noch einmal zeigen.
           Bleibt nichts übrig, wird der ganze Block „Passt perfekt dazu“ ausgeblendet. */
        var ids = Array.from(document.querySelectorAll('[data-sbx-item][data-pid]')).map(function (i) { return i.getAttribute('data-pid'); });
        if (ids.length) {
          Array.from(this.querySelectorAll('.swiper-slide')).forEach(function (sl) {
            var a = sl.querySelector('a[href*="pr_rec_pid="]');
            var m = a && a.getAttribute('href').match(/pr_rec_pid=(\d+)/);
            if (m && ids.indexOf(m[1]) > -1) sl.remove();
          });
          if (!this.querySelector('.swiper-slide')) {
            var blk = this.closest('.product__block--complementary') || this.closest('product-recommendations');
            if (blk) blk.style.display = 'none';
            return;
          }
        }
        var count = this.querySelectorAll('.swiper-slide').length;
        var two = count >= 2;
        if (two) this.classList.add('sb-two');
        if (count <= 2) this.classList.add('sb-fit');

        this.sliderOptions = {
          slidesPerView: 1,
          breakpoints: { 768: { slidesPerView: two ? 2 : 1 } },
          spaceBetween: 10,
          loop: false,
          grabCursor: false,
          allowTouchMove: true,
          autoHeight: false,
          navigation: {
            prevEl: this.querySelector('.swiper-button-prev'),
            nextEl: this.querySelector('.swiper-button-next'),
          },
          pagination: {
            el: this.querySelector('.swiper-pagination'),
            clickable: true,
            type: 'fraction',
          },
        };

        const slider = this.querySelector('.swiper');
        this.sliderInstance = new window.FoxTheme.Carousel(slider, this.sliderOptions);
        this.sliderInstance.init();

        this.fixQuickviewDuplicate();
      }

      fixQuickviewDuplicate() {
        let modalIds = [];
        Array.from(this.querySelectorAll('quick-view-modal')).forEach((modal) => {
          const modalID = modal.getAttribute('id');
          if (modalIds.includes(modalID)) {
            modal.remove();
          } else {
            modalIds.push(modalID);
          }
        });
      }
    }
  );
}
